import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import moduleLoader from "../services/moduleLoader";
import { getComponent } from "../services/simpleModuleLoader";
import Settings from "../pages/Settings";

// Dynamic routes component that loads from module registry
const DynamicRoutes = () => {
  const { user } = useAuth();
  const [routes, setRoutes] = React.useState([]);

  const normalizedRoles = Array.isArray(user?.roles)
    ? user.roles.map((role) => role?.toLowerCase()).filter(Boolean)
    : [];
  const isSuperAdmin =
    user?.role?.toLowerCase() === "super_admin" ||
    normalizedRoles.includes("super_admin");

  useEffect(() => {
    // Get all module routes
    const moduleRoutes = moduleLoader
      .getModuleRoutes()
      .filter((route) => route.moduleId !== "super-admin" || isSuperAdmin);

    // Add dashboard and settings routes
    const allRoutes = [
      { path: "/settings", component: Settings, exact: true },
      ...moduleRoutes,
    ];

    setRoutes(allRoutes);
  }, [isSuperAdmin]);

  return (
    <Routes>
      <Route path="/assistant/*" element={<Navigate to="/productivity-coaching" replace />} />
      <Route path="/dashboard" element={<Navigate to="/productivity-coaching" replace />} />
      <Route path="*" element={<Navigate to="/productivity-coaching" replace />} />
      {routes.map((route, index) => {
        // Use simple component loader for string components, original for function components
        const Component =
          typeof route.component === "string"
            ? getComponent(route.component)
            : route.component;

        return (
          <Route
            key={`${route.path}-${index}`}
            path={route.path}
            element={<Component />}
            exact={route.exact}
          />
        );
      })}
    </Routes>
  );
};

export default DynamicRoutes;
